// extracted by mini-css-extract-plugin
export default {"tag":"Fmhv_GZIHXzA4lzXgYj4","focus-visible":"_1xxhok0dR9oqk2afHlpi"};